import "./style.less";

export default function TableRowPeriodTime() {
    return {
        restrict: "E",
        scope: {
            start: "<",
            end: "<",
        },
        template: require("./template.html"),

        controller: function ($scope) {},
    };
}
